import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";

const UpdateBannerImg = ({
  isUpdateOpen,
  closeUpdateModal,
  uploadAndSaveImg,
  selectedImgUrl,
}) => {
  const [img, setImg] = useState();
  const [error, setError] = useState("")

  const handleSave = () => {
    if (!img) {
      setError("Image required")
      return
    }
    uploadAndSaveImg(img, "update");
    closeUpdateModal();
  };

  return (
    <Modal
      show={isUpdateOpen}
      onHide={closeUpdateModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Banner</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img src={selectedImgUrl} className="img-fluid mb-2" />
        {/* <Input
            label="Sequence of Banner"
            type="text"
            value={sequence}
            disabled={true}
          /> */}
        <Input
          label="Upload New Image"
          type="file"
          accept="image/png, image/jpeg"
          value={img}
          onChange={(e) => setImg(e.target.files[0])}
        />
        {error && <div className="text-danger">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button text="Save Changes" callBack={handleSave} />
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateBannerImg;
